import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tooltip } from 'antd';

import './index.less';
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';

const renderTitle = (status, title) => (
  title !== undefined && title !== ''
    ? title
    : status
);

const StatusIcon = ({ status = 'not defined', withTitle = false, title = undefined }) => {
  let Icon;
  switch (status.toLowerCase()) {
    case 'active':
    case 'accepted':
      Icon = CheckCircleFilled;
      break;
    case 'inactive':
    case 'declined':
      Icon = CloseCircleFilled;
      break;
    default:
      Icon = ExclamationCircleFilled;
      break;
  }

  return (
    <Tooltip
      placement="bottomRight"
      title={!withTitle && renderTitle(status, title)}
    >
      <Icon
        className={
          classnames(
            'status-icon',
            {
              'status-icon--pending': status === 'pending',
              'status-icon--accepted': ['received', 'accepted', 'active'].includes(status),
              'status-icon--declined': ['declined', 'inactive'].includes(status),
              'status-icon--has-hover-text': !withTitle,
            },
          )
        }
      />
      { withTitle && renderTitle(status, title) }
    </Tooltip>
  );
};

StatusIcon.displayName = 'StatusIcon';
StatusIcon.propTypes = {
  /**
   * Possible statuses, see styles -> less file.
   *
   * // Market party statuses
   * 'accepted', 'declined', 'pending'
   *
   * // Metering sites statuses
   * 'active', 'inactive'
   *
   * // Nominations statuses
   * 'received', 'declined', 'pending'
   */
  status: PropTypes.string,
  withTitle: PropTypes.bool,
  title: PropTypes.string,
};

export default StatusIcon;
